"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
exports.getInitialColumns = (showContextInfo) => {
    return [
        {
            key: 'Timestamp',
            name: 'Timestamp',
            fieldName: 'Timestamp',
            minWidth: 120,
            maxWidth: 160,
            isSorted: true,
            isSortedDescending: true,
            isResizable: true,
            onRender: (item) => react_1.default.createElement("span", null, (new Date(item.Timestamp)).toLocaleString()),
        },
        {
            key: 'Code',
            name: 'Code',
            fieldName: 'Code',
            minWidth: 80,
            maxWidth: 150,
            isResizable: true,
            sortAscendingAriaLabel: 'Sorted A to Z',
            sortDescendingAriaLabel: 'Sorted Z to A'
        },
        {
            key: 'Level',
            name: 'Level',
            fieldName: 'Level',
            minWidth: 50,
            maxWidth: 80,
            isResizable: true,
        },
        {
            key: 'Message',
            name: 'Message',
            fieldName: 'Message',
            minWidth: 250,
            maxWidth: 640,
            isResizable: true,
        },
        {
            key: 'CorrelationId',
            name: 'CorrelationId',
            fieldName: 'CorrelationId',
            minWidth: 120,
            maxWidth: 260,
            isResizable: true,
        },
        {
            key: 'Context',
            name: 'Context',
            fieldName: 'Context',
            minWidth: 85,
            maxWidth: 100,
            isResizable: true,
            onRender: (item) => item.Context ? react_1.default.createElement(office_ui_fabric_react_1.Link, { onClick: () => { var _a; return showContextInfo((_a = item.Context) !== null && _a !== void 0 ? _a : 'n/a'); } }, "View") : null
        }
    ];
};
